export const strMixin = {
  methods: {
    utf8_decode (s) {
      let result = s

      try {
        result = decodeURIComponent(escape(result))
      } catch (e) {
        console.error(e)
      }

      return result
    }
  }
}
